import { render, staticRenderFns } from "./DashboardTopMenu.vue?vue&type=template&id=08c23d7a&scoped=true"
import script from "./DashboardTopMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardTopMenu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DashboardTopMenu.vue?vue&type=style&index=0&id=08c23d7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c23d7a",
  null
  
)

export default component.exports